import { getSyiSlice } from 'tradera/apps/syi/state/selectors/syi';
import type { RootState } from 'tradera/state/configure-store';

export const selectMagicalSyiSettngEnabled = (state: RootState) =>
    !!getSyiSlice(state).draft.magicalSyiEnabled;

export const selectDraftId = (state: RootState) =>
    getSyiSlice(state).draft.draftId;

export const selectDraft = (state: RootState) => getSyiSlice(state).draft;
